import { ModuleWithProviders, Component, OnInit, OnDestroy, Injectable } from '@angular/core';
import { ActivatedRoute, Routes, RouterModule, DefaultUrlSerializer, UrlTree } from '@angular/router';
import { AppRoute } from './entities/app-config/model';
import { AppService } from './app.service';
import { FindRepairEstimateComponent } from './modules/wsre/pages/find-repair-estimate/find-repair-estimate.component';
import { RepairEstimateComponent } from './modules/wsre/pages/repair-estimate/repair-estimate.component';
import { ManageEquipmentComponent } from './modules/manage-equipment/manage-equipment.component';
import { UCInspectionsComponent } from './modules/uc-inspections/uc-inspections.component';
import { InterpretationComponent } from './modules/interpretation/pages/interpretation/interpretation.component';
import { SetupEquipmentComponent } from './modules/setup-equipment/pages/setup-equipment.component';
import { SetupUndercarriageOnEquipment, SetupUndercarriageInInventory, SetupUndercarraigeActionComponent } from './modules/setup-undercarriage';
import { RopeShovelInspectionComponent } from './modules/rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { EditPhotoTestComponent } from './shared/components/edit-photo-test/edit-photo-test.component';
import { ReportBuilderComponent } from './modules/rope-shovel/pages/report-builder/report-builder.component';
import { SelectEquipment } from './shared/components/select-equipment/select-equipment.component';
import { PreferencesComponent } from './modules/preferences/pages/preferences/preferences.component';
import { GeneralViewComponent } from './modules/preferences/pages/general-view/general-view.component';
import { AccountViewComponent } from './modules/preferences/pages/account-view/account-view.component';
import { AlertsViewComponent } from './modules/preferences/pages/alerts-view/alerts-view.component';
import { FindInspectionComponent } from './modules/inspection/pages/find-inspection/find-inspection.component';
import { InspectionListTableComponent } from './modules/inspection/components/inspection-list-table/inspection-list-table.component';
import { UnsyncedInspectionListTableComponent } from './modules/inspection/components/unsynced-inspection-list-table/unsynced-inspection-list-table.component';
import { RepairEstimateListTableComponent } from './modules/inspection/components/repair-estimate-list-table/repair-estimate-list-table.component';
import { MeasurementPointsDetailComponent } from './modules/measurement-points-admin/measurement-points-detail/measurement-points-detail.component';
import { MeasurementPointsAdminComponent } from './modules/measurement-points-admin/admin-component/measurement-points-admin.component';
import { CreateNewInspectionComponent } from './modules/inspection/create-new-inspection/create-new-inspection.component';
import { InspectionSortableTableComponent } from './modules/inspection/components/inspection-sortable-table/inspection-sortable-table.component';
import { InventoryComponent } from './modules/inventory/pages/inventory.component';
import { WsreSearchOnEquipmentComponent } from './modules/wsre-search-on-equipment/wsre-search-on-equipment.component';
import { ForecastInspectionStatisticsComponent } from './modules/GET_NEW_UI/forecast-inspection-statistics/forecast-inspection-statistics.component';
import { ManageComponentsComponent } from './modules/manage-components/pages/manage-components.component';
import { ComponentForecastComponent } from './modules/component-forecast/page/component-forecast.component';
import { SetupModelsComponent } from './modules/setup-models/pages/setup-models.component';
import { SetupFamilyComponent } from './modules/setup-family/pages/setup-family.component';
import { RecordActionComponent } from './modules/action/record-action/record-action.component';
import { AddInspectionObservationListsComponent } from './modules/inspection/add-inspection-observation-lists/add-inspection-observation-lists.component';
import { CustomerNotesComponent } from './modules/customer-notes/customer-notes.component';
import { ManageInspectionTypeComponent } from './modules/inspection/manage-inspection-type/manage-inspection-type.component';
import { InterpTemperatureInspectionComponent } from './modules/Temperature/interp-temperature-inspection/interp-temperature-inspection.component';
import { TemperatureListTableComponent } from './modules/inspection/components/temperature-list-table/temperature-list-table.component';
import { CreateNewThermographyInspectionComponent } from './modules/Thermography/create-new-thermography-inspection/create-new-thermography-inspection.component';
import { ThermographyListTableComponent } from './modules/inspection/components/thermography-list-table/thermography-list-table.component';
import { ManageCustomEvalComponent } from './modules/CustomEval/Page/manage-custom-eval.component';
import { SetupTrainingTypesComponent } from './modules/Training/setup-training-types/setup-training-types.component';
import { SetupTrainingComponent } from './modules/Training/setup-training/setup-training.component';
import { SetupTrainingQuestionsComponent } from './modules/Training/setup-training-questions/setup-training-questions.component';
import { ManageTrainingActivityComponent } from './modules/Training/manage-training-activity/manage-training-activity.component';
import { StartTrainingDetailsComponent } from './modules/Training/start-training-details/start-training-details.component';
import { TrainingSessionComponent } from './modules/Training/training-session/training-session.component';
import { ManageComponentCriticalityComponent } from './modules/manage-component-criticality/manage-component-criticality.component';
import { ComponentLifePerformanceComponent } from './modules/component-life-performance/component-life-performance.component';
import { EquipmentRecordActionComponent } from './modules/equipment-record-action/equipment-record-action.component';
import { CustomerContactComponent } from './modules/customer-contact/customer-contact.component';
import { JobrolePermissionsComponent } from './modules/jobrole-permissions/jobrole-permissions.component';
import { SetupEquipmentTestComponent } from './modules/setup-equipment-test/setup-equipment-test.component';
import { DashboardComponentGET } from './modules/GET_NEW_UI/dashboard/dashboard.component';
import { DigitalFormSearchComponent } from './modules/GET_NEW_UI/digital-form-search/digital-form-search.component';
import { ImplementDetailsComponent } from './modules/GET_NEW_UI/implement-details/implement-details.component';
import { GETSetupEquipmentComponent } from './modules/GET_NEW_UI/setup-equipment/setup-equipment.component';
import { SetupImplementComponent } from './modules/GET_NEW_UI/setup-implement/setup-implement.component';
import { ImplementTemplatesComponent } from './modules/GET_NEW_UI/implement-templates/implement-templates.component';
import { ImplementTemplateSetupComponent } from './modules/GET_NEW_UI/implement-template-setup/implement-template-setup.component';
import { CopyImplementComponent } from './modules/GET_NEW_UI/copy-implement/copy-implement.component';
import { EquipmentDetailsComponent } from './modules/GET_NEW_UI/equipment-details/equipment-details.component';
import { NewEquipmentInspectionComponent } from './modules/GET_NEW_UI/inspections/new-inspection/new-equipment-inspection/new-equipment-inspection.component';
import { GETInterpretationComponent } from './modules/GET_NEW_UI/inspections/interpretation/pages/interpretation.component';
import { DigitalFormSearchAdminstartionComponent } from './modules/GET_NEW_UI/digital-form-search-adminstartion/digital-form-search-adminstartion.component';
import { DigitalFormFillComponent } from './modules/GET_NEW_UI/digital-form-fill/digital-form-fill.component';
import { DigitalFormSectionQuestionsComponent } from './modules/GET_NEW_UI/digital-form-fill/component/digital-form-section-questions/digital-form-section-questions.component';
import { DigitalFormCategorylistComponent } from './modules/GET_NEW_UI/digital-form-fill/component/digital-form-categorylist/digital-form-categorylist.component';
import { GETFecrImplementRebuildDetailsComponent } from './modules/GET_NEW_UI/FECR/fecr-implement-rebuild-details/fecr-implement-rebuild-details.component';
import { FECRDashboardComponent } from './modules/GET_NEW_UI/FECR/FECRDashboard/dashboard/fecr-dashboard.component';
import { FecrObservationHistoryComponent } from './modules/GET_NEW_UI/FECR/fecr-observation-history/fecr-observation-history.component';
import { HomeComponent } from './modules/GET_NEW_UI/home/home.component';
import { SelectAFormComponent } from './modules/GET_NEW_UI/select-a-form/select-a-form.component';
import { UploadFormComponent } from './modules/GET_NEW_UI/upload-form/upload-form.component';
import { SearchFormAnalysisreportingComponent } from './modules/GET_NEW_UI/search-form-analysisreporting/search-form-analysisreporting.component';
import { SearchSafetyInspectionComponent } from './modules/GET_NEW_UI/search-safety-inspection/search-safety-inspection.component';
import { PerformInductionComponent } from './modules/GET_NEW_UI/perform-induction/perform-induction.component';
import { SearchInductionComponent } from './modules/GET_NEW_UI/search-induction/search-induction.component';
import { SetupInductionSlidesComponent } from './modules/GET_NEW_UI/setup-induction-slides/setup-induction-slides.component';
import { SafetyInductionSetupComponent } from './modules/GET_NEW_UI/safety-induction-setup/safety-induction-setup.component';
import { ConfigSetupDepartmentComponent } from './modules/GET_NEW_UI/config-setup-department/config-setup-department.component';
import { ConfigSetupChecklistComponent } from './modules/GET_NEW_UI/config-setup-checklist/config-setup-checklist.component';
import { ConfigSetupFormsComponent } from './modules/GET_NEW_UI/config-setup-forms/config-setup-forms.component';
import { ConfigSetupIncidentComponent } from './modules/GET_NEW_UI/config-setup-incident/config-setup-incident.component';
import { ConfigSetupInductionandSectionsComponent } from './modules/GET_NEW_UI/config-setup-inductionand-sections/config-setup-inductionand-sections.component';
import { ConfigViewEditMonHrsComponent } from './modules/GET_NEW_UI/config-view-edit-mon-hrs/config-view-edit-mon-hrs.component';
import { AddQuestionInducComponent } from './modules/GET_NEW_UI/setup-induction-question/add-question-induc/add-question-induc.component';
import { AnswerSetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/answer-setup-induction-question/answer-setup-induction-question.component';
import { EditSetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/edit-setup-induction-question/edit-setup-induction-question.component';
import { SetupInductionQuestionComponent } from './modules/GET_NEW_UI/setup-induction-question/setup-induction-question.component';
import { DigitalFormNewInspectionComponent } from './modules/GET_NEW_UI/digital-form-new-inspection/digital-form-new-inspection.component';
import { StartInductionComponent } from './modules/GET_NEW_UI/start-induction/start-induction.component';
import { SafetyObservationDashboardComponent } from './modules/GET_NEW_UI/safety-observation-dashboard/safety-observation-dashboard.component';
import { SafetyIndicatorsComponent } from './modules/GET_NEW_UI/safety-indicators/safety-indicators.component';
import { SafetyGeneralDashboardComponent } from './modules/GET_NEW_UI/SafetyAnalysisReport/safety-general-dashboard/safety-general-dashboard.component';
import { EnterSafetyInspectionDashboardComponent } from './modules/GET_NEW_UI/enter-safety-inspection-dashboard/enter-safety-inspection-dashboard.component';
import { CreateSafetyDigitalFormComponent } from './modules/GET_NEW_UI/create-safety-digital-form/create-safety-digital-form.component';
import { UploadDigitalFormsComponent } from './modules/GET_NEW_UI/upload-digital-forms/upload-digital-forms.component';
import { EditDigitalFormsComponent } from './modules/GET_NEW_UI/edit-digital-forms/edit-digital-forms.component';
import { UploadFormEditComponent } from './modules/GET_NEW_UI/upload-form-edit/upload-form-edit.component';
import { SetupWornLimitComponent } from './modules/setup-worn-limit/setup-worn-limit.component';
import { UserContactComponent } from './modules/user-contact/user-contact.component';
import { InspectionReportingModuleComponent } from './modules/inspection-reporting-module/inspection-reporting-module.component';
import { HomeNewComponent } from './modules/GET_NEW_UI/home-new/home-new.component';
import { HomescreenSafetyComponent } from './modules/GET_NEW_UI/homescreen-safety/homescreen-safety.component';
import { FecrPrePostShipmentObservationListComponent } from './modules/GET_NEW_UI/FECR/fecr-pre-post-shipment-observation-list/fecr-pre-post-shipment-observation-list.component';
import { FecrNewPrePostShipmentInspectionComponent } from './modules/GET_NEW_UI/FECR/fecr-new-pre-post-shipment-inspection/fecr-new-pre-post-shipment-inspection.component';
import { CopyImplmentAdvancedComponent } from './modules/GET_NEW_UI/copy-implment-advanced/copy-implment-advanced.component';
import { RepairEstimateFrameComponent } from './modules/wsre/pages/repair-estimate-frame/repair-estimate-frame.component';
import { DfiImplementDetailsComponent } from './modules/GET_NEW_UI/dfi-implement-details/dfi-implement-details.component';
import { DocumentInLibraryComponent } from './modules/document-in-library/document-in-library.component';
import { DocumentInLibrarySearchComponent } from './modules/document-in-library-search/document-in-library-search.component';
import { ImplementModelSetupComponent } from './modules/GET_NEW_UI/implement-model-setup/implement-model-setup.component';
import { ProductImprovementProgramComponent } from './modules/ProductImprovement/product-improvement-program/product-improvement-program.component';
import { ProductImprovementProgramSearchComponent } from './modules/ProductImprovement/product-improvement-program-search/product-improvement-program-search.component';
import { ProductImprovementForAssetComponent } from './modules/ProductImprovement/product-improvement-for-asset/product-improvement-for-asset.component';
import { SearchInspectionComponent } from './modules/GET_NEW_UI/search-inspection/search-inspection.component';
import { EmailfaxlogComponent } from './modules/GET_NEW_UI/emailfaxlog/emailfaxlog.component';
import { ImplementSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-setup/implement-setup.component';
import { ImplementComponentSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-component-setup/implement-component-setup.component';
import { ImplementObspointSetupComponent } from './modules/GET_NEW_UI/setup-implement/New Setup Implement/implement-obspoint-setup/implement-obspoint-setup.component';
import { WarrantyTypeSetupComponent } from './modules/warranty-type-setup/warranty-type-setup.component';
import { ObservationListCustomerComponent } from './modules/GET_NEW_UI/observation-list-customer/observation-list-customer.component';
import { MakeSetupComponent } from './modules/make-setup/make-setup.component';
import { JobPositionsComponent } from './modules/safety-job-positions/job-positions.component';
import { TrainingRegisterSearchComponent } from './modules/safety-job-positions/training-register-search/training-register-search.component';
import { DigitalFormReportsComponent } from './modules/GET_NEW_UI/digital-form-reports/digital-form-reports.component';
import { AdministrationComponent } from './modules/IDENTITY_WEB/administration/administration.component';
import { CreateDigitalFormComponent } from './modules/IDENTITY_WEB/create-digital-form/create-digital-form.component';
import { EditDigitalFormComponent } from './modules/IDENTITY_WEB/edit-digital-form/edit-digital-form.component';
import { AddThermographyAdditonalComponentComponent } from './modules/Thermography/add-thermography-additonal-component/add-thermography-additonal-component.component';
import { AddPolicyProcedureComponent } from './modules/GET_NEW_UI/policy-procedure/add-policy-procedure/add-policy-procedure.component';
import { SearchPolicyProcedureComponent } from './modules/GET_NEW_UI/policy-procedure/search-policy-procedure/search-policy-procedure.component';
import { SearchLeavesComponent } from './modules/GET_NEW_UI/Leaves/search-leaves/search-leaves.component';
import { LeaveAdministrationComponent } from './modules/GET_NEW_UI/Leaves/leave-administration/leave-administration.component';
import { LoginComponent } from './modules/GET_NEW_UI/login/login.component';
import { WelcomeComponent } from './modules/GET_NEW_UI/welcome/welcome.component';
import { inspectioneventsComponent } from './modules/inspection/pages/inspection-event/inspection-events.component';
import { TrackCareSearchComponent } from './modules/track-care-parts/track-care-search/track-care-search.component';
import { SetupComponentTypeComponent } from './setup-component-type/setup-component-type.component';
import { SMUPMServiceComponent } from './modules/manage-equipment/components/smu-pm-service/smu-pm-service.component';
import { UcPlannerComponent } from './modules/interpretation/components/uc-planner/uc-planner.component';
import { UcpActionRecommendationComponent } from './modules/interpretation/components/uc-planner/ucp-action-recommendation/ucp-action-recommendation.component';
import { SearchActionRecommnedationComponent } from './modules/interpretation/components/uc-planner/search-action-recommnedation/search-action-recommnedation.component';
import { ForecastSettingsAvgWearComponent } from './modules/interpretation/components/forecast-settings-avg-wear/forecast-settings-avg-wear.component';
import { UcplannerNewComponent } from './modules/interpretation/components/uc-planner/ucplanner-new/ucplanner-new.component';
import { ReportAlertComponent } from './modules/preferences/pages/report-alert/report-alert.component';
import { InspectionApiComponent } from './modules/inspection/pages/inspection-api/inspection-api.component';
import { ForecastSeasonalDatesComponent } from './modules/interpretation/components/forecast-seasonal-dates/forecast-seasonal-dates.component';

@Component({
    selector: 'app-router',
    template: '',
})
export class RedirectComponent implements OnInit, OnDestroy {

    constructor(private route: ActivatedRoute, private _appService: AppService) {
    }
    userRoot: AppRoute = new AppRoute();
    ngOnInit() {
        this.route
            .data
            .subscribe(data => {
                this.userRoot.routeEventTime = new Date();
                this.userRoot.routePath = data['routePath'];
                this.userRoot.routeId = +data['routeId'];
                this.userRoot.routeLevel = data['routeLevel'];
                this.userRoot.hasParam = data['hasParam'];
                this.userRoot.routeTitle = data['routeTitle'];
            });
        this.route.params.subscribe(params => {
            this.userRoot.itemId = +params['id'];
            console.log('route -> ', this.userRoot);
            this._appService.sendRouteMessage(this.userRoot);
        });
    }

    ngOnDestroy() {

    }
}


export const appRoutes: Routes = [
    { path: '', pathMatch: 'full', component: LoginComponent },
    { path: 'unsyncedinspection', redirectTo: '/inspection', pathMatch: 'full' },
    { path: 'unsyncedinspection/:id', component: UCInspectionsComponent },
    { path: 'equipment/:id', component: ManageEquipmentComponent },
    { path: 'setup-undercarriage', redirectTo: '/setup-undercarriage/on-equipment', pathMatch: 'full' },
    { path: 'setup-undercarriage/on-equipment', component: SetupUndercarriageOnEquipment },
    //{ path: 'setup-undercarriage/on-equipment/:isWSREInspection', component: SetupUndercarriageOnEquipment },
    { path: 'setup-undercarriage/in-inventory', component: SetupUndercarriageInInventory },
    { path: 'setup-undercarriage/in-action', component: SetupUndercarraigeActionComponent },
    { path: 'setup-undercarriage/on-equipment/:id', component: SetupUndercarriageOnEquipment },
    { path: 'setup-undercarriage/in-inventory/:id', component: SetupUndercarriageInInventory },
    { path: 'setup-undercarriage/in-inventory/:type/:customerId/:jobsite', component: SetupUndercarriageInInventory },
    { path: 'setup-undercarriage/in-inventory/:id/:id2/:id3/:id4', component: SetupUndercarriageInInventory },
    { path: 'setup-undercarriage/in-action/:id/:id2/:id3/:id4', component: SetupUndercarraigeActionComponent },
    { path: 'repair-estimate', component: FindRepairEstimateComponent },
    { path: 'repair-estimate/:id/:id2', component: RepairEstimateComponent },
    { path: 'repair-estimate-frame/:id/:id2', component: RepairEstimateFrameComponent },
    { path: 'interpretation', redirectTo: '/inspection', pathMatch: 'full' },
    { path: 'interpretation/:id', component: InterpretationComponent },
    { path: 'setup-equipment', component: SetupEquipmentComponent },
    { path: 'setup-equipment/:id', component: SetupEquipmentComponent },
    // { path: 'setup-equipment/:id/:unsyncedId', component: SetupEquipmentComponent },
    { path: 'rs-inspection', redirectTo: '/inspection', pathMatch: 'full' },
    { path: 'rs-inspection/equipment/:EquipmentId', component: RopeShovelInspectionComponent },
    { path: 'rs-inspection/report-builder', component: ReportBuilderComponent },
    { path: 'rs-inspection/report-builder/:id', component: ReportBuilderComponent },
    { path: 'rs-inspection/:id', component: RopeShovelInspectionComponent },
    { path: 'select-equipment/:ReturnRoute', component: SelectEquipment },
    { path: 'measurement-points', component: MeasurementPointsAdminComponent },
    { path: 'measurement-points/:id', component: MeasurementPointsDetailComponent },
    { path: 'edit-photo-test', component: EditPhotoTestComponent },
    { path: 'inventory/:id', component: InventoryComponent },

    { path: 'forecast-inspection-statistics', component: ForecastInspectionStatisticsComponent },
    { path: 'wsre-search-on-equipment/:id', component: WsreSearchOnEquipmentComponent },
    { path: 'add-new-inspection', component: CreateNewInspectionComponent },
    { path: 'setup-component', component: ManageComponentsComponent },
    { path: 'component-types', component: SetupComponentTypeComponent },
    { path: 'setup-families', component: SetupFamilyComponent },
    { path: 'setup-models', component: SetupModelsComponent },
    { path: 'setup-worn-limit', component: SetupWornLimitComponent },
    { path: 'setup-worn-limit/:id/:id2', component: SetupWornLimitComponent },

    { path: 'add-new-inspection/:id/:id2', component: CreateNewInspectionComponent, runGuardsAndResolvers: 'always' },

    { path: 'tempinspection', component: InterpTemperatureInspectionComponent },
    { path: 'tempinspection/:id', component: InterpTemperatureInspectionComponent },
    { path: 'tempinspection/:id/:id2', component: InterpTemperatureInspectionComponent },

    { path: 'thermography-inspection/:id/:id2', component: CreateNewThermographyInspectionComponent },


    { path: 'setup-component/:id', component: ManageComponentsComponent },
    { path: 'fleet-component-forecast', component: ComponentForecastComponent },

    { path: 'manage-observation-lists', component: AddInspectionObservationListsComponent },

    { path: 'manage-custom-eval', component: ManageCustomEvalComponent },

    { path: 'setup-training-types', component: SetupTrainingTypesComponent },
    { path: 'setup-training', component: SetupTrainingComponent },
    { path: 'setup-training-questions', component: SetupTrainingQuestionsComponent },
    { path: 'setup-training-questions/:id', component: SetupTrainingQuestionsComponent },
    { path: 'training-activity', component: ManageTrainingActivityComponent },
    { path: 'start-training', component: StartTrainingDetailsComponent },
    { path: 'start-training/:id/:id2', component: StartTrainingDetailsComponent },
    { path: 'start-training/:id/:id2/:id3', component: StartTrainingDetailsComponent },
    { path: 'training-session/:id/:id2', component: TrainingSessionComponent },
    { path: 'manage-component-criticality', component: ManageComponentCriticalityComponent },
    { path: 'component-performance', component: ComponentLifePerformanceComponent },
    { path: 'parts', component: TrackCareSearchComponent },
    { path: 'smu-pm-service', component: SMUPMServiceComponent },
    { path: 'parts/:id', component: TrackCareSearchComponent },
    { path: 'equipment-record-action', component: EquipmentRecordActionComponent },
    { path: 'equipment-record-action/:id', component: EquipmentRecordActionComponent },
    { path: 'equipment-record-action/:id/:smu', component: EquipmentRecordActionComponent },
    { path: 'equipment-record-action/:id/:smu/:editactiondate/:editaction', component: EquipmentRecordActionComponent },
    { path: 'customer-contact', component: CustomerContactComponent },
    { path: 'jobrole-permissions', component: JobrolePermissionsComponent },
    { path: 'setupequipment-test', component: SetupEquipmentTestComponent },
    { path: 'user-contact', component: UserContactComponent },
    { path: 'inspection-reporting', component: InspectionReportingModuleComponent },
    { path: 'login', component: LoginComponent },
    { path: 'welcome-treaktraeds', component: WelcomeComponent },
    { path: 'job-positions', component: JobPositionsComponent },
    { path: 'training-register', component: TrainingRegisterSearchComponent },
    { path: 'uc-plannerold', component: UcPlannerComponent },
    { path: 'uc-planner', component: UcplannerNewComponent },
     { path: 'forecastseasonaldates', component: ForecastSeasonalDatesComponent },
    { path: 'record-actions/:id', component: RecordActionComponent },
    { path: 'record-actions/:id/:id2/:id3', component: RecordActionComponent },
    { path: 'manage-inspection-types', component: ManageInspectionTypeComponent },
    { path: 'customer-notes', component: CustomerNotesComponent },
    { path: 'customer-notes/:id', component: CustomerNotesComponent },
    {
        path: 'preferences', component: PreferencesComponent,
        children: [
            { path: '', redirectTo: 'general', pathMatch: 'full' },
            { path: 'general', component: GeneralViewComponent },
            { path: 'account', component: AccountViewComponent },
            { path: 'alerts', component: AlertsViewComponent },
            { path: 'report', component: ReportAlertComponent }
        ]
    },
    {
        path: 'inspection', component: FindInspectionComponent,
        children: [
            { path: '', redirectTo: 'general', pathMatch: 'full' },
            { path: 'general', component: InspectionListTableComponent },
            { path: 'unsynced', component: UnsyncedInspectionListTableComponent },
            { path: 'estimates', component: RepairEstimateListTableComponent },
            { path: 'temperature', component: TemperatureListTableComponent },
            { path: 'thermography', component: ThermographyListTableComponent },
            { path: 'sortable', component: InspectionSortableTableComponent }
        ]
    },
    //NEW GETUI 
    { path: 'get/dashboard', component: DashboardComponentGET },
    { path: 'dfi/dashboard', component: DashboardComponentGET },
    {
        path: 'implementdetails',
        component: ImplementDetailsComponent
    },
    {
        path: 'setup/get-equipment',
        component: GETSetupEquipmentComponent
    },
    {
        path: 'setup/get-equipment/:id',
        component: GETSetupEquipmentComponent
    },
    {
        path: 'setup/implement',
        component: SetupImplementComponent
    },
    {
        path: 'setup/implement/:id',
        component: SetupImplementComponent
    },
    {
        path: 'implementdetails/:implementId',
        component: ImplementDetailsComponent
    },
    {
        path: 'dfi-implementdetails/:equipmentId',
        component: DfiImplementDetailsComponent
    },
    // {
    //     path: 'preferences',
    //     component: PreferencesComponent
    // },
    {
        path: 'template',
        component: ImplementTemplatesComponent
    },
    {
        path: 'template/setup',
        component: ImplementTemplateSetupComponent
    },
    {
        path: 'template/setup/:templateId',
        component: ImplementTemplateSetupComponent
    },
    {
        path: 'copy/implement',
        component: CopyImplementComponent
    },
    {
        path: 'copy/implement/advance',
        component: CopyImplmentAdvancedComponent
    },
    {
        path: 'copy/implement/advance/:implementId',
        component: CopyImplmentAdvancedComponent
    },
    {
        path: 'fecr/implementrebuilddetails/:implementId',
        component: GETFecrImplementRebuildDetailsComponent
    },
    {
        path: 'setup/existing-implement',
        component: SetupImplementComponent
    },
    {
        path: 'get-equipment',
        component: EquipmentDetailsComponent
    },
    {
        path: 'get-equipment/:equipmentId',
        component: EquipmentDetailsComponent
    },


    {
        path: 'get-inspection',
        component: NewEquipmentInspectionComponent
    },
    {
        path: 'get-inspection/:equipmentId',
        component: NewEquipmentInspectionComponent
    },


    {
        path: 'get-interpretation',
        component: GETInterpretationComponent
    },
    {
        path: 'get-interpretation/:equipmentId/:year/:month/:day',
        component: GETInterpretationComponent
    },
    {
        path: 'get-interpretation/inspection/:equipmentId/:inspectionId',
        component: GETInterpretationComponent
    },
    {
        path: 'get-interpretation/inspection/:inspectionId',
        component: GETInterpretationComponent
    },
    {
        path: 'get-inspection/:equipmentId/:implementId',
        component: NewEquipmentInspectionComponent
    },
    {
        path: 'digitalform/search',
        component: DigitalFormSearchComponent
    },

    {
        path: 'digitalform/reports/:formId/:uploadId',
        component: DigitalFormReportsComponent
    },

    {
        path: 'digitalform/search/:CatId',
        component: DigitalFormSearchComponent
    },
    {
        path: 'digitalform/adminsearch',
        component: DigitalFormSearchAdminstartionComponent
    },
    {
        path: 'digitalform/newinspection',
        component: DigitalFormNewInspectionComponent
    },
    {
        path: 'digitalform/fill/:formId/:uploadId',
        component: DigitalFormFillComponent
    },
    {
        path: 'digitalform/fill/:formId/:uploadId/:catId/:qId',
        component: DigitalFormSectionQuestionsComponent
    },
    {
        path: 'digitalform/fill_old/:formId/:uploadId/:catId',
        component: DigitalFormCategorylistComponent
    },

    {
        path: 'fecr/dashboard',
        component: FECRDashboardComponent
    },
    {
        path: 'fecr/obspointhistory/:implementId/:obsId',
        component: FecrObservationHistoryComponent
    },

    {
        path: 'fecr/setup/prepostinspection',
        component: FecrPrePostShipmentObservationListComponent
    },
    {
        path: 'fecr/prepostshipment/:implementId',
        component: FecrNewPrePostShipmentInspectionComponent

    },
    {
        path: 'fecr/prepostshipment/:implementId/:inspectionId',
        component: FecrNewPrePostShipmentInspectionComponent

    },

    //NEW CODE SAFETY
    // {path: 'about',component:AboutComponent},
    { path: 'safety/home', component: HomeComponent },
    { path: 'selectform', component: SelectAFormComponent },
    { path: 'form/uploadform', component: UploadFormComponent },
    { path: 'form/uploadform/:UploadId', component: UploadFormComponent },
    { path: 'uploadform/:Id', component: UploadFormComponent },

    { path: 'form/uploadformedit', component: UploadFormEditComponent },
    { path: 'form/uploadformedit/:UploadId', component: UploadFormEditComponent },
    { path: 'uploadformedit/:Id', component: UploadFormEditComponent },

    { path: 'searchform', component: SearchFormAnalysisreportingComponent },
    { path: 'safetyinspection/search', component: SearchSafetyInspectionComponent },
    { path: 'performinduction', component: PerformInductionComponent },
    { path: 'searchinduction', component: SearchInductionComponent },
    {
        path: 'setupinductionslide',
        component: SetupInductionSlidesComponent,
        children: [
            { path: 'safety', component: SafetyInductionSetupComponent },

        ]
    },
    { path: 'configsetupdepartment', component: ConfigSetupDepartmentComponent },
    { path: 'safetyobservationdashboardcomponent', component: SafetyObservationDashboardComponent },
    { path: 'configsetupforms', component: ConfigSetupFormsComponent },
    { path: 'createsafetydigitalform/:CatId', component: CreateSafetyDigitalFormComponent },
    { path: 'configsetupchecklist', component: ConfigSetupChecklistComponent },
    { path: 'configincident', component: ConfigSetupIncidentComponent },
    { path: 'configvieweditmonhr', component: ConfigViewEditMonHrsComponent },
    { path: 'configsetupinductionsection', component: ConfigSetupInductionandSectionsComponent },
    { path: 'setup/inductionquestion', component: SetupInductionQuestionComponent },
    { path: 'editsetupinductionquestion', component: EditSetupInductionQuestionComponent },
    { path: 'answersetupinductionquestion', component: AnswerSetupInductionQuestionComponent },
    { path: 'addsetupinductionquestion', component: AddQuestionInducComponent },
    { path: 'startinduction', component: StartInductionComponent },
    {
        path: 'startinduction/:InductionId',
        component: StartInductionComponent
    },
    { path: 'safetyindicatorscomponent', component: SafetyIndicatorsComponent },

    { path: 'safetygeneraldashboardcomponent', component: SafetyGeneralDashboardComponent },

    { path: 'inspection/index/:inspectionId', component: EnterSafetyInspectionDashboardComponent },
    { path: 'uploaddigitalformscomponent/upload/:FormId', component: UploadDigitalFormsComponent },
    { path: 'uploaddigitalformscomponent', component: UploadDigitalFormsComponent },
    { path: 'uploaddigitalformscomponent/:FormId', component: UploadDigitalFormsComponent },
    { path: 'editdigitalformscomponent/Edit/:Id', component: EditDigitalFormsComponent },
    { path: 'editdigitalformscomponent', component: EditDigitalFormsComponent },
    { path: 'editdigitalformscomponent/:Id', component: EditDigitalFormsComponent },
    { path: 'search-inspection', component: SearchInspectionComponent },
    { path: 'email-fax-log', component: EmailfaxlogComponent },
    { path: 'safety/homenew', component: HomeNewComponent },
    { path: 'safety/safetyhome', component: HomescreenSafetyComponent },
    { path: 'document-library', component: DocumentInLibraryComponent },
    {
        path: 'document-library/:DocumentId',
        component: DocumentInLibraryComponent
    },
    { path: 'document-library-search', component: DocumentInLibrarySearchComponent },
    { path: 'implement-model-setup', component: ImplementModelSetupComponent },
    { path: 'product-improvement-program', component: ProductImprovementProgramComponent },
    {
        path: 'product-improvement-program/:ProductProgramId',
        component: ProductImprovementProgramComponent
    },
    { path: 'product-improvement-program-search', component: ProductImprovementProgramSearchComponent },
    { path: 'product-improvement-asset', component: ProductImprovementForAssetComponent },
    {
        path: 'product-improvement-asset/:ImplementId/:Id/:PIPId',
        component: ProductImprovementForAssetComponent
    },

    {
        path: 'setup/existing-implement-new',
        component: ImplementSetupComponent
    },
    {
        path: 'setup/existing-implement-new/:implementId',
        component: ImplementSetupComponent
    },
    {
        path: 'setup/implement-new',
        component: ImplementSetupComponent
    },
    {
        path: 'setup/implement-new/:equipmentId',
        component: ImplementSetupComponent
    },
    {
        path: 'setup/implement-component/:implementId',
        component: ImplementComponentSetupComponent
    },
    {
        path: 'setup/implement-observation/:implementId',
        component: ImplementObspointSetupComponent
    },

    { path: 'warranty-type-setup', component: WarrantyTypeSetupComponent },

    { path: 'observation-list-customer', component: ObservationListCustomerComponent },
    { path: 'observation-list-customer/:Id/:FamId', component: ObservationListCustomerComponent },
    { path: 'make-setup', component: MakeSetupComponent },

    //Indentity
    { path: 'administrator', component: AdministrationComponent },
    { path: 'setup-digitalform', component: CreateDigitalFormComponent },
    { path: 'edit-digitalform', component: EditDigitalFormComponent },
    { path: 'edit-digitalform/:id', component: EditDigitalFormComponent },
    { path: 'setup-additional-components', component: AddThermographyAdditonalComponentComponent },
    { path: 'create-policies-procedures', component: AddPolicyProcedureComponent },
    {
        path: 'create-policies-procedures/:PolicyId',
        component: AddPolicyProcedureComponent
    },
    { path: 'search-policies-procedures', component: SearchPolicyProcedureComponent },

    { path: 'search-leave', component: SearchLeavesComponent },
    { path: 'leave-administration', component: LeaveAdministrationComponent },
    { path: 'equipment-action-recommendation/:id', component: UcpActionRecommendationComponent },
    { path: 'equipment-action-recommendation/:id/:smu', component: UcpActionRecommendationComponent },
    { path: 'search-action-recommendation', component: SearchActionRecommnedationComponent },
    { path: 'forecast-configuration', component: ForecastSettingsAvgWearComponent },

  { path: 'inspection/events', component: inspectioneventsComponent },
  { path: 'inspection/api', component: InspectionApiComponent },
  { path: 'inspection/api/:customer', component: InspectionApiComponent },
  { path: 'inspection/api/:customer/:jobsite', component: InspectionApiComponent },
  { path: 'inspection/api/:customer/:jobsite/:inspectiontype', component: InspectionApiComponent },

  { path: 'inspections/:customer', component: InspectionApiComponent },
  { path: 'inspections/:customer/:jobsite', component: InspectionApiComponent },
  { path: 'inspections/:customer/:jobsite/:inspectiontype', component: InspectionApiComponent },
  { path: 'inspections/:customer/:jobsite/:inspectiontype/:family', component: InspectionApiComponent },
  { path: 'inspections/:customer/:jobsite/:inspectiontype/:family/:model', component: InspectionApiComponent },
  
  { path: 'getcrackmapdata/api', component: InspectionApiComponent },
  { path: 'getcrackmapdata/api/:customer', component: InspectionApiComponent },
  { path: 'getcrackmapdata/api/:customer/:jobsite', component: InspectionApiComponent },
  { path: 'getcrackmapdata/api/:customer/:jobsite/:family', component: InspectionApiComponent },
  { path: 'getcrackmapdata/api/:customer/:jobsite/:family/:model', component: InspectionApiComponent },

  { path: 'ucinspection/api', component: InspectionApiComponent },
  { path: 'ucinspection/api/:customer', component: InspectionApiComponent },
  { path: 'ucinspection/api/:customer/:jobsite', component: InspectionApiComponent },
  { path: 'ucinspection/api/:customer/:jobsite/:family', component: InspectionApiComponent },
  { path: 'ucinspection/api/:customer/:jobsite/:family/:model', component: InspectionApiComponent },

  { path: 'equipmentcurrentcondition/api', component: InspectionApiComponent },
  { path: 'equipmentcurrentcondition/api/:customer', component: InspectionApiComponent },
  { path: 'equipmentcurrentcondition/api/:customer/:jobsite', component: InspectionApiComponent },
  { path: 'equipmentcurrentcondition/api/:customer/:jobsite/:family', component: InspectionApiComponent },
  { path: 'equipmentcurrentcondition/api/:customer/:jobsite/:family/:model', component: InspectionApiComponent }

];

export const routing: ModuleWithProviders<any> =
    RouterModule.forRoot(appRoutes, { onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' });

@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        return super.parse(url.toLowerCase());
    }
}
